import React from "react";
import Typography from "material-ui/Typography";
import Table from "material-ui/Table";
import { TableBody } from "material-ui/Table";
import { TableCell } from "material-ui/Table";
import { TableRow } from "material-ui/Table";

import { withStyles } from "material-ui/styles";
import styles from "./styles";
import { wifiDevice } from "./infoenum";
import { frequecyMHzToGHz } from "../../../../../common/utils"

const WiFiInt = props => (
  <Table className={props.classes.table}>
    <TableBody>
      <TableRow>
        <TableCell className={props.classes.tablecontent_first}>
          {props.translate("test_types_signaltek") + ":"}
        </TableCell>
        <TableCell className={props.classes.tablecontent_first}>
          {props.translate(props.data.type)}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={props.classes.tablecontent_first}>
          {props.translate("wifi_status") + ":"}
        </TableCell>
        <TableCell className={props.classes.tablecontent_first}>
          {props.data.wifi.status}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={props.classes.tablecontent_first}>
          {"SSID:"}
        </TableCell>
        <TableCell className={props.classes.tablecontent_first}>
          {props.data.wifi.hidden ? props.translate("hidden_ssid") : props.data.wifi.ssid}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={props.classes.tablecontent_first}>
          {"BSSID:"}
        </TableCell>
        <TableCell className={props.classes.tablecontent_first}>
          {props.data.wifi.macaddr}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={props.classes.tablecontent_first}>
          {props.translate("channel_frequency_no_units")}
        </TableCell>
        <TableCell className={props.classes.tablecontent_first}>
          {(props.data.wifi.channel ? props.data.wifi.channel : "-") + " / " +
           (props.data.wifi.frequency ? frequecyMHzToGHz(props.data.wifi.frequency) + " GHz" : "-") + " / " +
           (props.data.wifi.channelwidth ? props.data.wifi.channelwidth + " MHz" : "-")}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={props.classes.tablecontent_first}>
          {props.translate("security")}
        </TableCell>
        <TableCell className={props.classes.tablecontent_first}>
          {props.data.wifi.security}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={props.classes.tablecontent_first}>
          {props.translate("signal_strength")}
        </TableCell>
        <TableCell className={props.classes.tablecontent_first}>
          {props.data.wifi.signalstrengthdbm + "dBm (" + props.data.wifi.signalstrengthpercent + "%)"}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={props.classes.tablecontent_first}>
          {props.translate("bit_rate")}
        </TableCell>
        <TableCell className={props.classes.tablecontent_first}>
          {props.data.wifi.bitrate}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={props.classes.tablecontent_first}>
          {props.translate("wifi_device")}
        </TableCell>
        <TableCell className={props.classes.tablecontent_first}>
          {props.translate(wifiDevice.find(o => o.id === props.data.wifi.deviceid).name)}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={props.classes.tablecontent_first}>
          {props.translate("hidden_network")}
        </TableCell>
        <TableCell className={props.classes.tablecontent_first}>
          {props.data.wifi.hidden ? props.translate("back_btn_yes") : props.translate("back_btn_no")}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell className={props.classes.tablecontent_first}>
          {props.translate("web_login_required")}
        </TableCell>
        <TableCell className={props.classes.tablecontent_first}>
          {props.data.wifi.captiveportaldetected ? props.translate("back_btn_yes") : props.translate("back_btn_no")}
        </TableCell>
      </TableRow>
    </TableBody>
  </Table>
);
export default withStyles(styles)(WiFiInt);
